module.exports = __webpack_public_path__ + "img/2025-01_student-success.07f6d621.webp";